// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Control_MonadZero = require("../Control.MonadZero/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_List = require("../Data.List/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Unfoldable = require("../Data.Unfoldable/index.js");
var Effect = require("../Effect/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Halogen_Component = require("../Halogen.Component/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Events = require("../Halogen.HTML.Events/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Halogen_Query = require("../Halogen.Query/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Lunarbox_Component_Icon = require("../Lunarbox.Component.Icon/index.js");
var Lunarbox_Component_Tooltip = require("../Lunarbox.Component.Tooltip/index.js");
var Lunarbox_Component_Utils = require("../Lunarbox.Component.Utils/index.js");
var Lunarbox_Config = require("../Lunarbox.Config/index.js");
var Lunarbox_Data_Editor_FunctionName = require("../Lunarbox.Data.Editor.FunctionName/index.js");
var Web_HTML_HTMLElement = require("../Web.HTML.HTMLElement/index.js");
var Web_HTML_HTMLInputElement = require("../Web.HTML.HTMLInputElement/index.js");
var Web_UIEvent_KeyboardEvent = require("../Web.UIEvent.KeyboardEvent/index.js");
var Duplicate = (function () {
    function Duplicate(value0) {
        this.value0 = value0;
    };
    Duplicate.create = function (value0) {
        return new Duplicate(value0);
    };
    return Duplicate;
})();
var Empty = (function () {
    function Empty() {

    };
    Empty.value = new Empty();
    return Empty;
})();
var StartCreation = (function () {
    function StartCreation(value0) {
        this.value0 = value0;
    };
    StartCreation.create = function (value0) {
        return new StartCreation(value0);
    };
    return StartCreation;
})();
var CreatedFunction = (function () {
    function CreatedFunction(value0) {
        this.value0 = value0;
    };
    CreatedFunction.create = function (value0) {
        return new CreatedFunction(value0);
    };
    return CreatedFunction;
})();
var SelectedFunction = (function () {
    function SelectedFunction(value0) {
        this.value0 = value0;
    };
    SelectedFunction.create = function (value0) {
        return new SelectedFunction(value0);
    };
    return SelectedFunction;
})();
var CreateFunction = (function () {
    function CreateFunction() {

    };
    CreateFunction.value = new CreateFunction();
    return CreateFunction;
})();
var CancelCreation = (function () {
    function CancelCreation() {

    };
    CancelCreation.value = new CancelCreation();
    return CancelCreation;
})();
var SelectFunction = (function () {
    function SelectFunction(value0) {
        this.value0 = value0;
    };
    SelectFunction.create = function (value0) {
        return new SelectFunction(value0);
    };
    return SelectFunction;
})();
var ValidateFunctionName = (function () {
    function ValidateFunctionName() {

    };
    ValidateFunctionName.value = new ValidateFunctionName();
    return ValidateFunctionName;
})();
var showValidationError = new Data_Show.Show(function (v) {
    if (v instanceof Duplicate) {
        return "Function " + (v.value0 + " already exists.");
    };
    if (v instanceof Empty) {
        return "Function names cannot be empty";
    };
    throw new Error("Failed pattern match at Lunarbox.Component.Editor.Tree (line 31, column 1 - line 33, column 48): " + [ v.constructor.name ]);
});
var component = function (dictMonadEffect) {
    return function (dictMonadReader) {
        var validate = Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query.getHTMLElementRef("create-function-input-box"))(function (maybeElement) {
            return Data_Foldable.traverse_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(function (element) {
                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadEffect))(Web_HTML_HTMLInputElement.value(element)))(function (name) {
                    return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v) {
                        var $21 = Data_Maybe.isJust(Data_Foldable.find(Data_List_Types.foldableList)(function (v1) {
                            return Data_Eq.eq(Lunarbox_Data_Editor_FunctionName.eqFunctionName)(v1)(name);
                        })(v.functions));
                        if ($21) {
                            return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                var $22 = {};
                                for (var $23 in v1) {
                                    if ({}.hasOwnProperty.call(v1, $23)) {
                                        $22[$23] = v1[$23];
                                    };
                                };
                                $22.validationError = Data_Maybe.Just.create(new Duplicate(name));
                                return $22;
                            });
                        };
                        var $25 = name === "";
                        if ($25) {
                            return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                var $26 = {};
                                for (var $27 in v1) {
                                    if ({}.hasOwnProperty.call(v1, $27)) {
                                        $26[$27] = v1[$27];
                                    };
                                };
                                $26.validationError = Data_Maybe.Just.create(Empty.value);
                                return $26;
                            });
                        };
                        return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                            var $29 = {};
                            for (var $30 in v1) {
                                if ({}.hasOwnProperty.call(v1, $30)) {
                                    $29[$30] = v1[$30];
                                };
                            };
                            $29.validationError = Data_Maybe.Nothing.value;
                            return $29;
                        });
                    });
                });
            })(Control_Bind.bind(Data_Maybe.bindMaybe)(maybeElement)(Web_HTML_HTMLInputElement.fromHTMLElement));
        });
        var handleQuery = function (v) {
            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                var $34 = {};
                for (var $35 in v1) {
                    if ({}.hasOwnProperty.call(v1, $35)) {
                        $34[$35] = v1[$35];
                    };
                };
                $34.creating = true;
                return $34;
            }))(function () {
                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query.getHTMLElementRef("create-function-input-box"))(function (maybeElement) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadEffect))(Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)(Web_HTML_HTMLElement.focus)(maybeElement)))(function () {
                        return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value0));
                    });
                });
            });
        };
        var handleAction = function (v) {
            if (v instanceof CancelCreation) {
                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Lunarbox_Config.shouldCancelOnBlur(Halogen_Query_HalogenM.monadHalogenM)(Halogen_Query_HalogenM.monadAskHalogenM(dictMonadReader.MonadAsk0())))(function (shouldCancel) {
                    return Control_Applicative.when(Halogen_Query_HalogenM.applicativeHalogenM)(shouldCancel)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                        var $39 = {};
                        for (var $40 in v1) {
                            if ({}.hasOwnProperty.call(v1, $40)) {
                                $39[$40] = v1[$40];
                            };
                        };
                        $39.creating = false;
                        return $39;
                    }));
                });
            };
            if (v instanceof SelectFunction) {
                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                    var $42 = {};
                    for (var $43 in v1) {
                        if ({}.hasOwnProperty.call(v1, $43)) {
                            $42[$43] = v1[$43];
                        };
                    };
                    $42.selected = v.value0;
                    return $42;
                }))(function () {
                    return Halogen_Query_HalogenM.raise(new SelectedFunction(v.value0));
                });
            };
            if (v instanceof ValidateFunctionName) {
                return validate;
            };
            if (v instanceof CreateFunction) {
                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(validate)(function () {
                    return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v1) {
                        return Control_Applicative.when(Halogen_Query_HalogenM.applicativeHalogenM)(v1.creating)(Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query.getHTMLElementRef("create-function-input-box"))(function (maybeElement) {
                            return Data_Foldable.traverse_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(function (element) {
                                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadEffect))(Web_HTML_HTMLInputElement.value(element)))(function (name) {
                                    return Control_Applicative.when(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Maybe.isNothing(v1.validationError))(Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadEffect))(Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)(Web_HTML_HTMLElement.blur)(maybeElement)))(function () {
                                        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                                            var $47 = {};
                                            for (var $48 in v2) {
                                                if ({}.hasOwnProperty.call(v2, $48)) {
                                                    $47[$48] = v2[$48];
                                                };
                                            };
                                            $47.creating = false;
                                            $47.functions = Data_Semigroup.append(Data_List_Types.semigroupList)(v1.functions)(Control_Applicative.pure(Data_List_Types.applicativeList)(name));
                                            $47.selected = name;
                                            return $47;
                                        }))(function () {
                                            return Halogen_Query_HalogenM.raise(new CreatedFunction(name));
                                        });
                                    }));
                                });
                            })(Control_Bind.bind(Data_Maybe.bindMaybe)(maybeElement)(Web_HTML_HTMLInputElement.fromHTMLElement));
                        }));
                    });
                });
            };
            throw new Error("Failed pattern match at Lunarbox.Component.Editor.Tree (line 110, column 18 - line 147, column 53): " + [ v.constructor.name ]);
        };
        var displayFunction = function (selected) {
            return function (name) {
                return Halogen_HTML_Elements.div([ Halogen_HTML_Events.onClick(Data_Function["const"](Data_Maybe.Just.create(new SelectFunction(name)))), Halogen_HTML_Properties.classes(Data_Functor.map(Data_Functor.functorArray)(Halogen_HTML_Core.ClassName)(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ "explorer__function" ])(Data_Functor.voidRight(Data_Functor.functorArray)("explorer__function--selected")(Control_MonadZero.guard(Control_MonadZero.monadZeroArray)(Data_Eq.eq(Lunarbox_Data_Editor_FunctionName.eqFunctionName)(name)(selected)))))) ])([ Lunarbox_Component_Icon.icon("code"), Halogen_HTML_Elements.span([ Lunarbox_Component_Utils.className("no-overflow") ])([ Halogen_HTML_Core.text(Data_Show.show(Lunarbox_Data_Editor_FunctionName.showFunctionName)(name)) ]) ]);
            };
        };
        var render = function (v) {
            var inputAttribs = [ Lunarbox_Component_Utils.className("explorer__input"), Halogen_HTML_Events.onKeyUp(function (event) {
                return Control_Bind.discard(Control_Bind.discardUnit)(Data_Maybe.bindMaybe)(Control_MonadZero.guard(Data_Maybe.monadZeroMaybe)(Web_UIEvent_KeyboardEvent.key(event) === "Enter"))(function () {
                    return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(CreateFunction.value);
                });
            }), Halogen_HTML_Events.onBlur(Data_Function["const"](new Data_Maybe.Just(CancelCreation.value))), Halogen_HTML_Events.onInput(Data_Function["const"](new Data_Maybe.Just(ValidateFunctionName.value))), Halogen_HTML_Properties.autofocus(true), Halogen_HTML_Properties.ref("create-function-input-box"), Halogen_HTML_Properties.autocomplete(false) ];
            var newFunctionTextBox = Data_Functor.voidLeft(Data_Functor.functorArray)(Control_MonadZero.guard(Control_MonadZero.monadZeroArray)(v.creating))(Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("explorer__input-container") ])([ Lunarbox_Component_Icon.icon("code"), (function () {
                if (v.validationError instanceof Data_Maybe.Nothing) {
                    return Halogen_HTML_Elements.input(inputAttribs);
                };
                if (v.validationError instanceof Data_Maybe.Just) {
                    return Lunarbox_Component_Tooltip.tooltip(Data_Show.show(showValidationError)(v.validationError.value0))(Lunarbox_Component_Tooltip.Bottom.value)(Halogen_HTML_Elements.input)(inputAttribs);
                };
                throw new Error("Failed pattern match at Lunarbox.Component.Editor.Tree (line 210, column 15 - line 216, column 33): " + [ v.validationError.constructor.name ]);
            })() ]));
            var existingFunctions = Data_List.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Functor.map(Data_List_Types.functorList)(displayFunction(v.selected))(v.functions));
            return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("explorer") ])(Data_Semigroup.append(Data_Semigroup.semigroupArray)(existingFunctions)(newFunctionTextBox));
        };
        return Halogen_Component.mkComponent({
            initialState: function (v) {
                return {
                    functions: v.functions,
                    selected: v.selected,
                    creating: false,
                    validationError: Data_Maybe.Nothing.value
                };
            },
            render: render,
            "eval": Halogen_Component.mkEval({
                handleAction: handleAction,
                handleQuery: handleQuery,
                receive: Halogen_Component.defaultEval.receive,
                initialize: Halogen_Component.defaultEval.initialize,
                finalize: Halogen_Component.defaultEval.finalize
            })
        });
    };
};
module.exports = {
    Duplicate: Duplicate,
    Empty: Empty,
    CreateFunction: CreateFunction,
    CancelCreation: CancelCreation,
    SelectFunction: SelectFunction,
    ValidateFunctionName: ValidateFunctionName,
    StartCreation: StartCreation,
    CreatedFunction: CreatedFunction,
    SelectedFunction: SelectedFunction,
    component: component,
    showValidationError: showValidationError
};
